import { render, staticRenderFns } from "./BodegaReporteCodigosLiquidadosAnios.vue?vue&type=template&id=a2a8e8f6"
import script from "./BodegaReporteCodigosLiquidadosAnios.vue?vue&type=script&lang=js"
export * from "./BodegaReporteCodigosLiquidadosAnios.vue?vue&type=script&lang=js"
import style0 from "./BodegaReporteCodigosLiquidadosAnios.vue?vue&type=style&index=0&id=a2a8e8f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports